import { Col, Form, InputNumber, Modal, Row, Select, Switch } from "antd";
import { useForm } from "antd/es/form/Form";
import React from "react";
import { useParams } from "react-router-dom";
import PayrollYearlySettingsService, { CarAllowanceListType, FuelTypesOptionList } from "../../Services/PayrollYearlySettingsService";
import { getEnumName } from "../../Common/CommonComponent";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddCarAllowanceItem = ({
  onDismiss,
  itemId,
  record,
  carAllowanceListType,
  isViewOnly = false
}: any) => {
  const [form] = useForm();
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const { openNotification } = React.useContext(adminContext);

  var ty = getEnumName(carAllowanceListType, CarAllowanceListType);

  React.useEffect(() => {
    if (itemId !== undefined && itemId !== null && itemId !== "") {
      form.setFieldsValue({
        id: record?.id,
        fuelType: record?.fuelType,
        calcPer: record?.calcPer,
        isOld: record?.isOld,
      });
      if (carAllowanceListType === CarAllowanceListType.CarCo2Emmission) {
        form.setFieldsValue({
          co2EmmisionFrom: record?.co2EmmisionFrom,
          co2EmmisionTo: record?.co2EmmisionTo,
        });
      } else if (carAllowanceListType === CarAllowanceListType.CarEngineSize) {
        form.setFieldsValue({
          engineSizeFrom: record?.engineSizeFrom,
          engineSizeTo: record?.engineSizeTo,
        });
      } else if (carAllowanceListType === CarAllowanceListType.CarEleRange) {
        form.setFieldsValue({
          eleRangeFrom: record?.eleRangeFrom,
          eleRangeTo: record?.eleRangeTo,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, record, carAllowanceListType]);
  return (
    <SAModal
      footer={isViewOnly ? null : undefined}
      title={itemId ? `Edit ${ty} Allowance item` : `Add ${ty} Allowance item`}
      width={560}
      open={true}
      okText={"Save"}
      cancelText={"Cancel"}
      okButtonProps={{ loading: loading }}
      onCancel={() => onDismiss(false)}
      onOk={async () => {
        setLoading(true);
        const yearlySettingsRecordId = id ?? "";
        const ItemId = itemId ?? "";
        form.validateFields().then(async (values) => {
          const val = { ...values, id: record?.id }
          let res = await PayrollYearlySettingsService.updateCarAllowanceItem(
            yearlySettingsRecordId,
            carAllowanceListType,
            val,
            ItemId
          );
          if (res.status) {
            openNotification("success", "Details updated successfully");
            onDismiss(true);
            setLoading(false);
          } else {
            openNotification("error", res.message);
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      }}
    >
      <Form form={form} disabled={isViewOnly} requiredMark={false}>
        <Row gutter={[10, 10]}>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Mandatory field",
                },
              ]}
              label="Fuel type"
              name="fuelType"
            >
              <Select
                placeholder="Select Fuel type"
                className="select-height-28"
                options={FuelTypesOptionList}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[10, 10]}>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Calculation percentage"
              name="calcPer"
            >
              <InputNumber
                controls={false}
                placeholder="Calculation percentage"
                prefix="%"
                onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                style={{ width: "100%", height: 28 }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label="Is old"
              name="isOld"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>


          {carAllowanceListType === CarAllowanceListType.CarCo2Emmission && (
            <>
              <Col xs={24} sm={12}>
                <Form.Item
                  className="custom-form-item"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label="Co2 emmission from"
                  name="co2EmmisionFrom"
                >
                  <InputNumber
                    controls={false}
                    placeholder="Co2 emmission from"
                    prefix="g/km"
                    onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                    style={{ width: "100%", height: 28 }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  className="custom-form-item"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label="Co2 emmission to"
                  name="co2EmmisionTo"
                >
                  <InputNumber
                    controls={false}
                    placeholder="Co2 emmission to"
                    prefix="g/km"
                    onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                    style={{ width: "100%", height: 28 }}
                  />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>

        {carAllowanceListType === CarAllowanceListType.CarEngineSize && (
          // <Row className="px-3 py-1">
          <>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Engine size from"
                name="engineSizeFrom"
              >
                <InputNumber
                  controls={false}
                  placeholder="Engine size from"
                  prefix="cc"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Engine size to"
                name="engineSizeTo"
              >
                <InputNumber
                  controls={false}
                  placeholder="Engine size to"
                  prefix="cc"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </>
          // </Row>
        )}

        {carAllowanceListType === CarAllowanceListType.CarEleRange && (
          // <Row className="px-3 py-1">
          <>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Ele Range from"
                name="eleRangeFrom"
              >
                <InputNumber
                  controls={false}
                  placeholder="Ele Range from"
                  prefix="cc"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 18 }}
                label="Ele Range to"
                name="eleRangeTo"
              >
                <InputNumber
                  controls={false}
                  placeholder="Ele Range to"
                  prefix="cc"
                  onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </>
          // </Row>
        )}
      </Form>
    </SAModal>
  );
};

export default AddCarAllowanceItem;
